import moment from "moment";
import Culture from "@/module/main/page/CultureEnum";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import IApplicationForm from "@/module/main/model/applicationForm/IApplicationForm";

abstract class BaseMapper {
    protected formatDate(date: Date | undefined): string | undefined
    {

        return date && moment(date).format("YYYY-MM-DD") || undefined
    }

    protected stringToNumber(price: string): number | undefined
    {

        let num = Number.parseFloat(price.replace(",", "."));

        return Number.isNaN(num) ? undefined : num;
    }

    public isCz(culture: Culture): boolean
    {
        return culture === Culture.CZ;
    }

    public isSk(culture: Culture): boolean
    {
        return culture === Culture.SK;
    }

    public isOrder(application: IApplicationForm): boolean
    {
        return application.loan.financedSubjectType === FinancedSubjectType.ORDER;
    }

    public isWallet(application: IApplicationForm): boolean
    {
        return application.loan.financedSubjectType === FinancedSubjectType.WALLET;
    }
}

export default BaseMapper;
